import { render } from "./appConfig.vue?vue&type=template&id=5fe7ceee&ts=true"
import script from "./appConfig.vue?vue&type=script&lang=ts"
export * from "./appConfig.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__